import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import shallow from 'zustand/shallow';
import i18n from '@pureartisan/simple-i18n';
import useStore from './../store';
import { DEMO_MAX_PERCENTS, CPAL_LAYERS } from './../../../../constants/layers';
import { DEMO_COLORS } from './../../../../constants/colors';
import { getRoundedValue } from './../utils';

var CensusScale = function CensusScale(_ref) {
  var props = _extends({}, _ref); // Max for the scale.


  var _useState = useState(100),
      scaleMax = _useState[0],
      setScaleMax = _useState[1]; // Active layers


  var activeLayers = useStore(function (state) {
    return [].concat(state.activeLayers);
  }, shallow);

  var _useState2 = useState(i18n.translate('UI_MAP_LAYER_1_TITLE')),
      scaleLabel = _useState2[0],
      setScaleLabel = _useState2[1]; // Update scale max when the active layer changes.


  useEffect(function () {
    // console.log(
    //   'activelayers changed, updating max scale value in legend',
    // )
    var min = 2;
    var max = 6;

    for (var i = min; i < max + 1; i++) {
      if (activeLayers[i] === 1) {
        setScaleLabel(i18n.translate(CPAL_LAYERS[i].label));
      }
    }

    var newMax = null;

    switch (true) {
      case !!activeLayers[2]:
        setScaleMax(getRoundedValue(DEMO_MAX_PERCENTS[CPAL_LAYERS[2].metric] * 100, 2, false));
        break;

      case !!activeLayers[3]:
        setScaleMax(getRoundedValue(DEMO_MAX_PERCENTS[CPAL_LAYERS[3].metric] * 100, 2, false));
        break;

      case !!activeLayers[4]:
        setScaleMax(getRoundedValue(DEMO_MAX_PERCENTS[CPAL_LAYERS[4].metric] * 100, 2, false));
        break;

      case !!activeLayers[5]:
        setScaleMax(getRoundedValue(DEMO_MAX_PERCENTS[CPAL_LAYERS[5].metric] * 100, 2, false));
        break;

      case !!activeLayers[6]:
        setScaleMax(getRoundedValue(DEMO_MAX_PERCENTS[CPAL_LAYERS[6].metric] * 100, 2, false));
        break;

      default:
        setScaleMax(getRoundedValue(DEMO_MAX_PERCENTS[CPAL_LAYERS[2].metric] * 100, 2, false));
    }
  }, [activeLayers]);
  return /*#__PURE__*/React.createElement("div", {
    className: "census-scale"
  }, /*#__PURE__*/React.createElement("h5", null, scaleLabel), /*#__PURE__*/React.createElement("div", {
    className: "scale-parent"
  }, /*#__PURE__*/React.createElement("div", {
    className: "scale-block scale-block-0",
    style: {
      backgroundColor: DEMO_COLORS[0]
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "scale-block scale-block-1",
    style: {
      backgroundColor: DEMO_COLORS[1]
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "scale-block scale-block-2",
    style: {
      backgroundColor: DEMO_COLORS[2]
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "scale-block scale-block-3",
    style: {
      backgroundColor: DEMO_COLORS[3]
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "scale-block scale-block-4",
    style: {
      backgroundColor: DEMO_COLORS[4]
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "scale-range"
  }, /*#__PURE__*/React.createElement("div", {
    className: "scale-range-minmax min"
  }, "0%"), /*#__PURE__*/React.createElement("div", {
    className: "scale-range-minmax max"
  }, scaleMax, "%")));
};

export default CensusScale;